export default __webpack_public_path__ + "static/media/2240.09cd7633.png";